import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OdrService } from '../service/odr.service';

import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Link } from '../shared/models/link';
import { AppServiceService } from '../service/app-service.service';

export interface State {
  flag: string;
  name: string;
  population: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  searchValue: string;
  public aFormGroup: FormGroup;
  odrlink : Link;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  states: any;
  
  constructor(private odrService: OdrService, public formBuilder: FormBuilder, private titleService: Title,
    private appService: AppServiceService) {
  	this.filteredStates = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this._filterStates(state) : this.states.slice())
      );
   }
  

  ngOnInit(): void {
    //this.getOdrLink();
    
    this.aFormGroup = this.formBuilder.group({
      searchValue: new FormControl(null, Validators.required)
    });
    
    this.titleService.setTitle('UC Davis Directory');
    this.appService.setSearchString('');
  }

  getOdrLink(): void {
    this.odrService.getOdrLink().subscribe(o => 
      this.odrlink = o);
  }

  updateHeader() {
	this.appService.setTitle('UC Davis Directory');
  }



  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();

    return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

}
